export default "../css/ad0c9a18b0366d37042c6ffb9519585c.ttf";